<template>
  <div class="card">
    <div class="card-content">
      <question-title :question="question" class="mb1"></question-title>

      <div class="field mt1" v-for="field in question.fields">
        <div class="control">
          <input
            class="input"
            :placeholder="field.choice"
            v-model="field.value"
            :name="field.choice"
            @input="recordAnswer()"
          />
        </div>
      </div>

      <next-button :id="question.id" :choice="choice"></next-button>
      <reset-button></reset-button>
    </div>
  </div>
</template>

<script>
import baseQuestion from "./baseQuestion";

export default {
  name: "multitext",

  mixins: [baseQuestion],

  methods: {
    recordAnswer() {
      let next = false;

      this.question.fields.forEach((field, index) => {
        this.choice[index] = { choice: field.choice, value: field.value };
        if (this.question.required === true) {
          //require all inputs
          if (field.value) {
            next = true;
          } else {
            next = false;
          }
        } else {
          next = true;
        }
      });

      this.$store.dispatch("interview/setNext", next);
    }
  }
};
</script>
